var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tracked-ui",class:{
    visible: _vm.visible,
  },style:(("\n    top: " + (_vm.coords.y) + "%;\n    left: " + (_vm.coords.x) + "%;\n  "))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }